// 用于图片的放大 拖拽  打点--yhjadd
import {Bus} from '$utils'

const mixin = {
  data() {
    return {
      vW: 100,
      vH: 100,
      vWmin: 100, //放大-缩小 w最小倍数
      vHmin: 100, //放大-缩小 w最小倍数
      zoomStep: 10, //一次放大缩小的比例
      moveXDistance: 0,
      moveYDistance: 0,
      marginTop: 0,
      marginLeft: 0,
      mouseWheelRecord: null,
      imgW: 20,
      imgH: 20,
      checkData: [], //选中拖动数据
      checkIndex: "",
      ishaveMove: false,
    }
  },
  beforeDestroy() {},
  created() {},
  methods: {
    // 以下为共用function
    getImgPath(item) {
      return item ? Bus.imgPath(item) : ''
    },
    // 滚轮放大缩小
    mouseScroll(e) {
      // console.log(e)
      this.poverVisible ? this.poverVisible = false : ""
      let xh = e.offsetX / this.cW
      let yh = e.offsetY / this.cH
      let direction = (e.deltaY || e.detail) > 0 ? "down" : "up";
      if (direction === "up") {
        // 放大
        this.vW += this.zoomStep;
        this.vH += this.zoomStep;
        this.SaveMouseWheelInfo(this.vW);
      } else {
        // 缩小
        if (this.vW === this.vWmin) return;
        this.vW = this.vW - this.zoomStep;
        this.vH = this.vH - this.zoomStep;
        // this.getWheelRecord(this.vW);
        if (this.vW < this.vWmin) {
          this.vW = this.vWmin;
          this.marginLeft = 0;
          this.moveXDistance = 0;
        }
        if (this.vH < this.vHmin) {
          this.vH = this.vHmin;
          this.marginTop = 0;
          this.moveYDistance = 0;
        }
      }
      // 原地爆炸
      this.$nextTick(() => {
        if (this.isOther) {
          this.changeCanvas(e)
          return
        }
        let newW = document.querySelector(".canvasMainT").offsetWidth
        // console.log(document.querySelector(".canvasMainT"))
        let newH = document.querySelector(".canvasMainT").offsetHeight
        let moveX = newW * xh - e.offsetX
        let moveY = newH * yh - e.offsetY
        this.marginTop = Math.round(this.marginTop - moveY)
        this.marginLeft = Math.round(this.marginLeft - moveX)
      })
    },
    // 缩小到曾经的位置 --可用可不用
    getWheelRecord(wheel) {
      if (this.mouseWheelRecord[`wheel_${wheel}`]) {
        const [x, y] = this.mouseWheelRecord[`wheel_${wheel}`];
        // this.marginLeft = x;
        // this.marginTop = y;
        this.mouseWheelRecord[`wheel_${wheel}`] = null;
        delete this.mouseWheelRecord[`wheel_${wheel}`];
      }
    },
    // 保存放大后数据--可用可不用
    SaveMouseWheelInfo(wheel) {
      if (!this.mouseWheelRecord) {
        this.mouseWheelRecord = {};
      }
      //保存放大是的top left
      this.mouseWheelRecord[`wheel_${wheel}`] = [
        this.marginLeft,
        this.marginTop
      ];
    },
    // 鼠标按下事件--拖动
    handleDomMoveStart(e) {
      // console.log(e)
      this.visibleTip ? this.visibleTip = false : ''
      if (e.button > 1) {
        // 目前默认左轮点击
        if (e.button == 2) {
          // 右轮点击
        }
        return
      }
      e.preventDefault();
      //点击选中数据
      // console.log("开始")
      if (this.imgIsmove) {
        let x = e.offsetX
        let y = e.offsetY
        this.checkData = this.canvasList.filter((el, index) => {
          let wb = this.cW / el.width;
          let hb = this.cH / el.height;
          return Math.pow(x - el.x * wb, 2) + Math.pow(y - el.y * hb, 2) < 100
        })
        if (this.checkData.length) {
          this.canvasList.forEach((el, index) => {
            if (el.deviceId == this.checkData[0].deviceId) {
              this.checkIndex = index
              this.canvasList.splice(index, 1, {})
              // this.canvasList.splice(index, 1)
              this.oldCanvasData.splice(index, 1)
            } else {
              delete el.img
            }
          })
        }
      }
      const startX = e.clientX; //鼠标相对游览器左上角的位置
      const startY = e.clientY;
      document.querySelector("#mycanvas").style.cursor = "move"; //拖动的元素
      let that = this
      const moveEvent = e => {
        if (that.checkData.length && that.imgIsmove) {
          // 判断是否出界
          that.ishaveMove = true
          if (e.offsetX > that.cW || e.offsetY > that.cH) {
            return
          }
          that.clearCanvas()
          that.checkData[0].x = e.offsetX
          that.checkData[0].y = e.offsetY
          that.checkData[0].width = that.cW
          that.checkData[0].height = that.cH
          that.checkData[0].img = "check"
          that.canvasList.splice(that.checkIndex, 1, that.checkData[0])
          // that.canvasList.push(that.checkData[0])
          that.mathCanvas()
          return
        }
        // 移动中的位置
        const _videoElement = document.querySelector("#mycanvas");
        const _videoW = _videoElement.offsetWidth;
        const _videoH = _videoElement.offsetHeight;
        const _videoBoxElement = document.querySelector(".canvasMain"); //拖动元素的父元素
        const _boxW = _videoBoxElement.offsetWidth;
        const _boxH = _videoBoxElement.offsetHeight;
        const _maxY = _videoH - _boxH;
        const _maxX = _videoW - _boxW;
        this.moveXDistance = e.clientX - startX;
        this.moveYDistance = e.clientY - startY;
        // 保护机制  防止四边出界-可用可不用
        // if (this.getMarinLeft > 0) {
        //   this.moveXDistance = -this.marginLeft;
        // }
        // if (this.getMarginTop > 0) {
        //   this.moveYDistance = -this.marginTop;
        // }
        // if (Math.abs(this.getMarinLeft) > _maxX) {
        //   this.moveXDistance = -(_maxX - Math.abs(this.marginLeft));
        // }
        // if (Math.abs(this.getMarginTop) > _maxY) {
        //   this.moveYDistance = -(_maxY - Math.abs(this.marginTop));
        // }
      };
      // 移动结束事件
      const moveEnd = e => {
        if (this.imgIsmove && this.checkData.length) {
          if (!this.canvasList[this.checkIndex].deviceId) {
            // 防单击出错--单击时可能只触发开始和结束事件 需要将开始时处理的数据重新设置
            this.canvasList.splice(this.checkIndex, 1, this.checkData[0])
            this.oldCanvasData.splice(this.checkIndex, 0, this.checkData[0])
          }
        }
        this.checkData = []
        this.checkIndex = []
        document.removeEventListener("mousemove", moveEvent);
        document.removeEventListener("mouseup", moveEnd);
        this.marginTop += this.moveYDistance;
        this.marginLeft += this.moveXDistance;
        this.moveXDistance = 0;
        this.moveYDistance = 0;
        document.querySelector("#mycanvas").style.cursor = "default";
        // 移除事件
      };
      // 注册document鼠标移动事件
      document.addEventListener("mousemove", moveEvent);
      document.addEventListener("mouseup", moveEnd);
    },
    // 绘制画笔
    initCanvas(id = 'mycanvas') {
      var canvas = document.getElementById(id);
      return canvas.getContext("2d");
    },

    // 以下为单独使用function
    // 图纸添加位置信息
    daDrawImg(flag, x, y, r, item, id = 'mycanvas') {
      let ctx = this.initCanvas(id);
      let ix = r || this.imgW
      let ir = r * 2 || this.imgW * 2
      // let src = '/images/theme/custom/fire/default/SENU087_27.png'
      let src = ""
      if (item.subDeviceMark) {
        // 部件
        if (flag === 'blue') {
          let ref = 'Bdefault' + item.subDeviceMark
          src = this.$refs.fireImg.$refs[ref]
        } else if (flag === 'yellow') {
          let ref = 'Bchecked' + item.subDeviceMark
          src = this.$refs.fireImg.$refs[ref]
        }
      } else {
        // 主机和其他
        if (item.deviceMark == 18) {
          // 摄像机
          src = [this.$refs.cameraImg]
        } else if (item.deviceMark == 32) {
          // 电气火灾
          src = [this.$refs.dqhzImg]
        } else {
          if (flag === 'blue') {
            let ref = 'Zdefault' + item.deviceMark
            src = this.$refs.fireImg.$refs[ref]
          } else if (flag === 'yellow') {
            let ref = 'Zchecked' + item.deviceMark
            src = this.$refs.fireImg.$refs[ref]
          }
        }
      }
      this.$nextTick(() => {
        if (!src) {
          if (flag === 'blue') {
            src = this.$refs.img;
          } else if (flag === 'yellow') {
            src = this.$refs.imgCheck
          }
          ctx.drawImage(src, x - ix, y - ix, ir, ir);
          return
        }
        ctx.drawImage(src[0], x - ix, y - ix, ir, ir);
      })
    },
    // 图纸重绘
    redrawImg(r) {
      // console.log(r)
      // console.log(this.canvasChangList)
      let ix = r || this.imgW
      let ir = r * 2 || this.imgW * 2
      // 动态画图
      if (this.canvasList.length) {
        let ctx = this.initCanvas();
        var img = this.$refs.img;
        // 图像各异
        this.canvasList.forEach(el => {
          el.img = el.img || 'blue'
          let wb = this.cW / el.width;
          let hb = this.cH / el.height;
          // 消防告警的闪烁图层专用
          if (this.showAlarm) {
            this.showAlarmImg(el, wb, hb)
            return
          }
          this.daDrawImg(el.img, el.abscissa * wb, el.ordinate * hb, ir, el, )
        })
      }
      // 静态图层
      if (this.canvasChangList && this.canvasChangList.length) {
        // 图像各异
        this.canvasChangList.forEach(el => {
          el.img = 'blue'
          let wb = this.cW / el.width;
          let hb = this.cH / el.height;
          // 消防告警的闪烁图层专用
          this.daDrawImg(el.img, el.abscissa * wb, el.ordinate * hb, 1.25 * r || 10, el, "mycanvas2")
        })
      }
    },
    //清空画布
    clearCanvas(id = "mycanvas") {
      let ctx = this.initCanvas(id);
      var canvas = document.getElementById(id);
      let data = canvas.height
      canvas.height = 0;
      canvas.height = data;
      ctx.clearRect(0, 0, this.cH, this.cW, );
    },
    // 画布点击 && 回调
    clickCanvas() {
      let that = this;
      var canvas = document.getElementById("mycanvas");
      var ctx = canvas.getContext("2d");
      var x, y;
      canvas.addEventListener("click", function (e) {
        that.showTip(e)
      });
    },
    showTip(e) {
      // 点击相对坐标
      let x = e.offsetX
      let y = e.offsetY
      //点击选中数据
      let checkData = this.canvasList.filter((el, index) => {
        let wb = this.cW / el.width;
        let hb = this.cH / el.height;
        return Math.pow(x - el.x * wb, 2) + Math.pow(y - el.y * hb, 2) < 100
      })
      // 寻找第一个接近的数据点
      if (checkData.length) {
        // 点击事件 发起气泡
      }
    },
  }
}
export default mixin
